import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export const AuthImage = ({ photoId, base = "/damages/photos", className, onClick, testId }) => {
  const [src, setSrc] = useState(null);
  useEffect(() => {
    let url;
    api.get(`${base}/${photoId}`, { responseType: "blob" })
      .then((r) => { url = URL.createObjectURL(r.data); setSrc(url); })
      .catch(() => setSrc(""));
    return () => url && URL.revokeObjectURL(url);
  }, [photoId, base]);
  if (src === null) return <div className={`animate-pulse bg-slate-100 ${className}`} />;
  if (!src) return <div className={`grid place-items-center bg-slate-100 text-xs text-slate-400 ${className}`}>Foto non disponibile</div>;
  return <img src={src} alt="Foto danno" className={`object-cover ${className}`} onClick={onClick} data-testid={testId} />;
};
